/* Cozihop — theme.js */
(function () {
  'use strict';
  var doc = document;
  doc.documentElement.classList.remove('no-js');
  var T = window.theme || {};
  var routes = T.routes || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };

  /* ---------- Drawers (cart, menu, search) ---------- */
  var lastFocus = null;
  function getDrawer(name) { return doc.querySelector('[data-drawer="' + name + '"]'); }
  function openDrawer(name) {
    var d = getDrawer(name); if (!d) return false;
    lastFocus = doc.activeElement;
    d.classList.add('is-open');
    doc.body.classList.add('no-scroll');
    var f = d.querySelector('input[type="search"], [data-autofocus], button, a');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    return true;
  }
  function closeDrawers() {
    doc.querySelectorAll('[data-drawer].is-open').forEach(function (d) { d.classList.remove('is-open'); });
    doc.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  doc.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var name = opener.getAttribute('data-open');
      if (name === 'cart' && !T.cartDrawer) return;
      if (openDrawer(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart (AJAX) ---------- */
  function setCount(n) {
    doc.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = !(n > 0);
    });
  }
  function renderDrawer(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-cart-content]');
    var current = doc.querySelector('[data-cart-content]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    }
  }
  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) { renderDrawer(s['cart-drawer']); });
  }

  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || !T.cartDrawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.textContent = '';
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        if (res.j.sections && res.j.sections['cart-drawer']) renderDrawer(res.j.sections['cart-drawer']);
        else return refreshDrawer();
      })
      .then(function () { openDrawer('cart'); })
      .catch(function (ex) { if (err) err.textContent = ex.message; else alert(ex.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
  });

  function changeLine(line, qty) {
    var content = doc.querySelector('[data-cart-content]');
    if (content) content.classList.add('is-loading');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.sections && j.sections['cart-drawer']) renderDrawer(j.sections['cart-drawer']);
        else return refreshDrawer();
        if (j.status && j.description) alert(j.description);
      })
      .catch(function () { window.location.href = routes.cart; })
      .finally(function () { var c = doc.querySelector('[data-cart-content]'); if (c) c.classList.remove('is-loading'); });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (!b) return;
    var drawer = b.closest('[data-cart-content]');
    if (!drawer) return; // cart page uses normal form submit
    e.preventDefault();
    changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-line-qty'), 10));
  });

  /* Cart page: auto-submit when a quantity changes */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-page-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-page-qty'), 10));
    input.value = v;
    input.form.submit();
  });
  doc.addEventListener('change', function (e) {
    if (e.target.matches('[data-page-qty-input]')) e.target.form.submit();
  });

  /* ---------- Header scrolled state ---------- */
  var header = doc.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Announcement rotation ---------- */
  doc.querySelectorAll('[data-announce]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, speed);
  });

  /* ---------- Rails ---------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rail-dir]');
    if (!b) return;
    var sec = b.closest('[data-rail-section]');
    var rail = sec && sec.querySelector('.rail');
    if (rail) rail.scrollBy({ left: rail.clientWidth * 0.9 * parseInt(b.getAttribute('data-rail-dir'), 10), behavior: 'smooth' });
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var els = (scope || doc).querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  initReveal();
  doc.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });

  /* ---------- Collection filters ---------- */
  doc.querySelectorAll('[data-filter-form]').forEach(function (form) {
    var t;
    form.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { form.submit(); }, 250); });
  });
  doc.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  var filterPanel = doc.querySelector('[data-filter-panel]');
  if (filterPanel && window.matchMedia('(min-width: 861px)').matches) filterPanel.open = true;

  /* ---------- Address country selects ---------- */
  doc.querySelectorAll('select[data-default]').forEach(function (sel) {
    var v = sel.getAttribute('data-default'); if (v) sel.value = v;
  });

  /* ---------- Product recommendations ---------- */
  doc.querySelectorAll('[data-recs-url]').forEach(function (box) {
    fetch(box.getAttribute('data-recs-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs-url]');
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; initReveal(box); }
      })
      .catch(function () {});
  });
})();
